var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLevel1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6286 4.07152C11.867 3.97616 12.133 3.97616 12.3714 4.07152L22.3714 8.07152C22.751 8.22339 23 8.5911 23 9V15C23 15.5523 22.5523 16 22 16C21.4477 16 21 15.5523 21 15V10.477L19 11.277V16C19 17.3662 17.939 18.3912 16.6899 19.0157C15.3939 19.6637 13.7065 20 12 20C10.2935 20 8.60606 19.6637 7.31015 19.0157C6.06101 18.3912 5 17.3662 5 16V11.277L1.62861 9.92848C1.24895 9.77661 1 9.4089 1 9C1 8.5911 1.24895 8.22339 1.62861 8.07152L11.6286 4.07152ZM6.39251 9.67997C6.3784 9.67394 6.36413 9.66823 6.3497 9.66285L4.69258 9L12 6.07703L19.3074 9L17.6503 9.66285C17.6359 9.66823 17.6216 9.67394 17.6075 9.67997L12 11.923L6.39251 9.67997ZM7 12.077V16C7 16.2251 7.20327 16.7262 8.20457 17.2269C9.15909 17.7042 10.5239 18 12 18C13.4761 18 14.8409 17.7042 15.7954 17.2269C16.7967 16.7262 17 16.2251 17 16V12.077L12.3714 13.9285C12.133 14.0238 11.867 14.0238 11.6286 13.9285L7 12.077Z",
    fill: "#4C6EF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel1);
export default __webpack_public_path__ + "static/media/level1.c2614d8a9e407f8196e336083e3fcdf0.svg";
export { ForwardRef as ReactComponent };